<template>
  <div class="content-wrapper">
    <div class="flex mb-4">
      <div class="lg:w-full w-full bg-grid-color h-12">
        <vs-card class="px-5 py-5">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Promotion Title</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input
                v-validate="'required'"
                name="promotitle"
                class="w-full"
                v-model="form.promotitle"
                :maxlength="200"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('promotitle')"
                >{{ errors.first("promotitle") }}</span
              >
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Description</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-textarea
                v-validate
                name="promodesc"
                class="w-full"
                v-model="form.promodesc"
                :maxlength="200"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('promodesc')"
                >{{ errors.first("promodesc") }}</span
              >
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Discount Type</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <ul class="demo-alignment">
                <li>
                  <vs-radio v-model="form.disctype" vs-value="percent"
                    >Percent (%)</vs-radio
                  >
                </li>
                <li>
                  <vs-radio v-model="form.disctype" vs-value="amount"
                    >Baht</vs-radio
                  >
                </li>
              </ul>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Discount </span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input
                v-validate="{ required: true }"
                name="discvalue"
                class="w-full"
                v-model="form.discvalue"
                onkeypress="return /^[0-9]*\.?[0-9]*$/i.test(event.key)"
                onpaste="return false"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('discvalue')"
                >{{ errors.first("discvalue") }}</span
              >
            </div>
          </div>
          <!-- <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Discount from</span>
                <div style="font-size:0.75rem; color:#aaa;"></div>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <ul style="display:inline-block; padding-top:15px;">
                  <li style="display:inline-block">
                    <vs-radio
                      v-model="form.discfrom"
                      vs-value="fullprice"
                      class="mx-3"
                      >Full Price</vs-radio
                    >
                  </li>
                  <li style="display:inline-block">
                    <vs-radio
                      v-model="form.discfrom"
                      vs-value="currentprice"
                      class="mx-3"
                      >Current Price</vs-radio
                    >
                  </li>
                </ul>
              </div>
            </div> -->

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Period</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <flat-pickr
                :config="{ enableTime: true, dateFormat: 'Y-m-d H:i' }"
                v-model="form.date_start"
                placeholder="Date Time Start"
              />
              <span class="mx-4">to</span>
              <flat-pickr
                :config="{ enableTime: true, dateFormat: 'Y-m-d H:i' }"
                v-model="form.date_end"
                placeholder="Date Time End"
              />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Discount On</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <ul class="demo-alignment">
                <li>
                  <vs-radio v-model="form.disclevel" :vs-value="1">All</vs-radio>
                </li>
                <li>
                  <vs-radio v-model="form.disclevel" :vs-value="2"
                    >Selective Tickets</vs-radio
                  >
                </li>
              </ul>
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Used</span>
              <div style="font-size:0.75rem; color:#aaa;"></div>
            </div>
            <div class="vx-col sm:w-2/3 w-full"></div>
          </div>

          <div v-if="form.disclevel == 2" class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              Select the tickets the discount is applicable to
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <ul class="centerx">
                <li
                  v-for="(item, i) in productList"
                  :key="i"
                  style="margin:12px 0;"
                >
                  <vs-checkbox v-model="item.selected">{{
                    item.pro_name
                  }}</vs-checkbox>
                </li>
              </ul>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Note attached to order (Internal use)</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-textarea
                class="w-full"
                v-model="form.promonote"
              />
              <!-- <span
                class="text-danger text-sm"
                v-show="errors.has('promonote')"
                >{{ errors.first("promonote") }}</span
              > -->
            </div>
          </div>
          <div style="height:30px;"></div>
          <div class="vx-row pt-2 mt-0">
            <div class="vx-col w-full ml-auto">
              <vs-button class="mr-3 mb-2" @click="validateForm"
                >Save
              </vs-button>

              <vs-button class="mr-3 mb-2" type="border" @click="cancel()"
                >Cancel
              </vs-button>
            </div>
          </div>
        </vs-card>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import { mapState } from "vuex";

import Service from "@/services";
import { timezones } from "@/utils/Timezones";

import VxAutoSuggest from "@/components/vx-auto-suggest/VxAutoSuggest.vue";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  components: {
    VxAutoSuggest,
    flatPickr
  },
  props: ["promocode_id"],
  computed: {
    ...mapState({
      accessToken: state => {
        return state.Auth.accessToken;
      },
      s: state => {
        return state.Utility.s;
      },
      e: state => {
        return state.Utility.e;
      }
    })
  },
  data() {
    return {
      form: {
        // promo_id: null,
        // promo_type: null,
        // promotitle: null,
        // promodesc: null,
        // disctype: "percent",
        // discvalue: null,
        // discfrom: null,
        // disclevel: 1,
        // applyto: null,
        // date_start: null,
        // date_end: null,
        // qty: null,
        // used: null,
        // pccode: null,
        // token: null,
        // promonote: null,
        // promo_status: null,
        // weight: null
      },
      productList: []
    };
  },
  created() {
    let data = {
      e: this.e
    };

    let params = Object.keys(data)
      .map(key => key + "=" + data[key])
      .join("&");

    Service.Product.gets(params).then(res => {
      this.productList = res.data.rows.map(item => {
        return { ...item, selected: false };
      });

      Service.Bootsale.getPromo(this.promocode_id, params)
        .then(promo => {
          this.form = promo.data.promo;

          this.form.discfrom = promo.data.promo.discfrom;
          if (this.form.disclevel === "order") {
            this.form.disclevel = 1;
          } else {
            this.form.disclevel = 2;
          }

          this.form.date_start = moment(promo.data.promo.date_start).format(
            "YYYY-MM-DD HH:mm"
          );
          this.form.date_end = moment(promo.data.promo.date_end).format(
            "YYYY-MM-DD HH:mm"
          );
          console.log(this.form.date_start);
          console.log(promo.data.promo.date_start);

          promo.data.relation.map(item => {
            if (item.applyto_tbl == "product") {
              let index = this.productList.findIndex(
                x => x.product_id == item.applyto_id
              );
              if (index >= 0) {
                this.productList[index].selected = true;
              }
            }
          });
        })
        .catch(error => {});
    });
  },
  methods: {
    validateForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          // if form have no errors
          this.submit();
        } else {
          // form have errors
        }
      });
    },
    cancel() {
      this.$router.push("/promotions?s=" + this.s + "&e=" + this.e);
    },
    submit() {
      this.form.e = this.e;

      this.$vs.loading();

      Service.Bootsale.updatePromo(this.form.promo_id, this.form)
        .then(res => {
          if (res.success) {
            this.$vs.notify({
              title: "Success",
              text: "Update promocode completed.",
              color: "success"
            });
          }
          // this.$router.push("/promotions?s=" + this.s + "&e=" + this.e);
          this.$vs.loading.close();
        })
        .catch(err => {
          this.$vs.notify({
            title: "Oops!",
            text: "ERROR : " + err.error,
            color: "danger"
          });
          this.$vs.loading.close();
        });
    }
  }
};
</script>
